import React from 'react';
import './DeleteCircleButton.scss';

const DeleteCircleButton = props => (
  <div {...props} className="delete-circle-button">
    <div className="delete-circle-button__flex-container">
      <i className="far fa-trash-alt" />
    </div>
  </div>
);

export default DeleteCircleButton;
